import { useContext } from "react";
import { UseQueryResult, useQuery } from "@tanstack/react-query";

import { AxiosContext } from "contexts/AxiosContext";
import { AttachmentDetail } from "interfaces/attachment";
import { PaginatedResponse } from "interfaces/utils";

const STALE_TIME = 1000 * 60 * 15;

export const useCaseCreationTemplatesQuery = ({
  enabled = true
}: {
  enabled?: boolean;
}): UseQueryResult<AttachmentDetail, unknown> => {
  const { axios } = useContext(AxiosContext)!;

  return useQuery({
    queryKey: ["Case Creation Templates"],
    queryFn: async () => {
      const { data } = await axios.get<PaginatedResponse<AttachmentDetail[]>>(
        `/case_creation_templates`
      );

      return data.results[0] ?? null;
    },
    enabled: enabled,
    staleTime: STALE_TIME
  });
};
